import { BROWSERS, OPERATING_SYSTEMS } from './constants';

const { userAgent } = navigator;

const detectOS = () => {
  if (userAgent) {
    if (userAgent.toLowerCase().includes(OPERATING_SYSTEMS.MAC)) {
      return OPERATING_SYSTEMS.MAC;
    }
    if (userAgent.toLowerCase().includes(OPERATING_SYSTEMS.WINDOWS)) {
      return OPERATING_SYSTEMS.WINDOWS;
    }
    if (userAgent.toLowerCase().includes(OPERATING_SYSTEMS.CHROME)) {
      return OPERATING_SYSTEMS.CHROME;
    }
  }

  return OPERATING_SYSTEMS.UNKNOWN;
};

const detectBrowser = () => {
  // Order dependent search
  if (/OPR/.test(userAgent)) {
    return [BROWSERS.OPERA, userAgent.split('OPR/').at(1)];
  }

  if (/Edg/.test(userAgent)) {
    return [BROWSERS.EDGE, userAgent.split('Edg/').at(1)];
  }

  if (/Trident/.test(userAgent)) {
    return [BROWSERS.IE, userAgent.split('Trident/').at(1)];
  }

  if (/Firefox/.test(userAgent)) {
    return [BROWSERS.FIREFOX, userAgent.split('Firefox/').at(1)];
  }

  if (/Silk/.test(userAgent)) {
    return [BROWSERS.SILK, userAgent.split('Silk/').at(1)];
  }

  if (/Chrome/.test(userAgent) && !/Chromium/.test(userAgent)) {
    return [BROWSERS.CHROME, userAgent.split('Chrome/')[1].substring(0, 9)];
  }

  if (/Safari/.test(userAgent) && !/Chrome/.test(userAgent)) {
    return [BROWSERS.SAFARI, userAgent.split('Safari/').at(1)];
  }

  return [BROWSERS.UNKNOWN, 0];
};

const _isBrowserSupported = (browser: string | number | undefined) =>
  browser === BROWSERS.CHROME || browser === BROWSERS.EDGE || browser === BROWSERS.SILK;

// Some browsers "support" bluetooth but don't actually allow the SDK to get the bluetooth adaptor
const getBluetooth = () => {
  if ('bluetooth' in navigator) {
    return true;
  }
  return false;
};

export const isMacOs = (os: string) => os === OPERATING_SYSTEMS.MAC;

export const getUserAgentInfo = () => {
  const os = detectOS();
  const browser = detectBrowser();
  const hasBluetooth = getBluetooth();
  const isBrowserSupported = _isBrowserSupported(browser[0]);
  const userAgentInfo = { browser: browser[0], version: browser[1], os, hasBluetooth, isBrowserSupported }; // Browser | Version | OS | hasBluetooth

  return userAgentInfo;
};

export default getUserAgentInfo();
